package com.anjuros.website.templates.template1.util


import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey: ResKeyType {



    TEMPLATE1_SECTION1,
    TEMPLATE1_SECTION2,
    TEMPLATE1_SECTION3,
    TEMPLATE1_SECTION4,
    TEMPLATE1_REVIEW1,
    TEMPLATE1_REVIEW1_TITLE,
    TEMPLATE1_REVIEW2,
    TEMPLATE1_REVIEW2_TITLE,
    TEMPLATE1_REVIEW3,
    TEMPLATE1_REVIEW3_TITLE,
    TEMPLATE1_REVIEW4,
    TEMPLATE1_REVIEW4_TITLE,
    TEMPLATE1_REVIEW5,
    TEMPLATE1_REVIEW5_TITLE,
    TEMPLATE1_REVIEW6,
    TEMPLATE1_REVIEW6_TITLE,

    TEMPLATE1_HERO_BADGE,

    TEMPLATE1_HERO_TITLE,

    TEMPLATE1_HERO_SUBTITLE,

    TEMPLATE1_HERO_BUTTON1,

    TEMPLATE1_HERO_BUTTON2,


    TEMPLATE1_SERVICE1_TITLE,
    TEMPLATE1_SERVICE2_TITLE,
    TEMPLATE1_SERVICE3_TITLE,
    TEMPLATE1_SERVICE4_TITLE,

    TEMPLATE1_PRICES_BADGE,
    TEMPLATE1_PRICES_TITLE,
    TEMPLATE1_SERVICE_DESC2,

    TEMPLATE1_PRICE1_TITLE,
    TEMPLATE1_PRICE2_TITLE,
    TEMPLATE1_PRICE3_TITLE,
    TEMPLATE1_PRICE4_TITLE,
    TEMPLATE1_PRICE5_TITLE,
    TEMPLATE1_PRICE6_TITLE,

    TEMPLATE1_GALLERY_BADGE,
    TEMPLATE1_GALLERY_TITLE,
    TEMPLATE1_SERVICE_DESC,

    TEMPLATE1_INFO_DESC,
    TEMPLATE1_ABOUT_TITLE,
    TEMPLATE1_ABOUT_PARAGRAPH,

    TEMPLATE1_HERO_FEATURE1_TITLE,
    TEMPLATE1_HERO_FEATURE1_TEXT,

    TEMPLATE1_HERO_FEATURE2_TITLE,
    TEMPLATE1_HERO_FEATURE2_TEXT,

    TEMPLATE1_HERO_FEATURE3_TITLE,
    TEMPLATE1_HERO_FEATURE3_TEXT,

    TEMPLATE1_HERO_FEATURE4_TITLE,
    TEMPLATE1_HERO_FEATURE4_TEXT,

    TEMPLATE1_REVIEWS_BADGE,
    TEMPLATE1_REVIEWS_TITLE,
    TEMPLATE1_REVIEWS_TEXT,



    TEMPLATE1_CONTACT_BADGE,
    TEMPLATE1_CONTACT_TITLE,
    TEMPLATE1_CONTACT_SUBTITLE,

    TEMPLATE1_CONTACT_SUBTITLE2,

    TEMPLATE1_CONTACT_ADDRESS_TITLE,
    TEMPLATE1_CONTACT_PHONE_TITLE,
    TEMPLATE1_CONTACT_EMAIL_TITLE
    ;


    override val keyName: String
        get() = name

}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(


        ResKey.TEMPLATE1_SECTION1 to "Service",
        ResKey.TEMPLATE1_SECTION2 to "Reviews",
        ResKey.TEMPLATE1_SECTION3 to "Prices",
        ResKey.TEMPLATE1_SECTION4 to "Contact me",
        ResKey.TEMPLATE1_REVIEW1_TITLE to "Amazing Experience!",
        ResKey.TEMPLATE1_REVIEW1 to "I had the best experience at this salon! The stylist really listened to what I wanted and gave me the perfect cut and colour. I left feeling like a whole new person! Highly recommend!",
        ResKey.TEMPLATE1_REVIEW2_TITLE to "Professional and Friendly",
        ResKey.TEMPLATE1_REVIEW2 to "The staff here is not only super professional, but they make you feel right at home. I got a balayage treatment, and the result was stunning! My hair looks and feels healthier than ever. I’ll definitely be coming back!",
        ResKey.TEMPLATE1_REVIEW3_TITLE to "Beyond Satisfied!",
        ResKey.TEMPLATE1_REVIEW3 to "I’ve never been more satisfied with my hair! The stylist gave me exactly what I wanted, and even offered some great advice on maintenance. The whole experience was relaxing and enjoyable. Can't wait to book my next appointment!",
        ResKey.TEMPLATE1_REVIEW4_TITLE to "A Hair Miracle!",
        ResKey.TEMPLATE1_REVIEW4 to "After years of bad haircuts, I finally found a place that gets me! The stylist gave me a gorgeous new bob and totally transformed my look. I’m getting so many compliments, and I’m thrilled with how it turned out.",
        ResKey.TEMPLATE1_REVIEW5_TITLE to "Great Service and Results!",
        ResKey.TEMPLATE1_REVIEW5 to "I came in for a major colour change, and I couldn’t be happier! The stylist was so knowledgeable and made sure I was comfortable with every step. My hair turned out exactly how I envisioned, and the results were absolutely beautiful.",
        ResKey.TEMPLATE1_REVIEW6_TITLE to "Review",
        ResKey.TEMPLATE1_REVIEW6 to "Had an amazing experience! My stylist, listened to exactly what I wanted and gave me the perfect cut. The salon was clean and welcoming, and I left feeling confident with my hair looking great. Highly recommend!",

        ResKey.TEMPLATE1_HERO_BADGE to "Luxury Hair Salon",

        ResKey.TEMPLATE1_HERO_TITLE to "Luxury Hair Styling",

        ResKey.TEMPLATE1_HERO_SUBTITLE to "Whether you're looking for a fresh cut, beautiful colour or styling for a special event, I'm here to help you look and feel your best.",

        ResKey.TEMPLATE1_HERO_BUTTON1 to "Book Appointment",

        ResKey.TEMPLATE1_HERO_BUTTON2 to "View Gallery",

        ResKey.TEMPLATE1_SERVICE1_TITLE to "Bridal",
        ResKey.TEMPLATE1_SERVICE2_TITLE to "Colour",
        ResKey.TEMPLATE1_SERVICE3_TITLE to "Balayage",
        ResKey.TEMPLATE1_SERVICE4_TITLE to "Cut",



        ResKey.TEMPLATE1_PRICES_BADGE to "Price List",

        ResKey.TEMPLATE1_PRICES_TITLE to "Simple, Transparent Pricing",

        ResKey.TEMPLATE1_SERVICE_DESC2 to "Choose from a range of professional hair services. If you're looking for something bespoke, feel free to get in touch for a personalised quote.",

        ResKey.TEMPLATE1_PRICE1_TITLE to "Women's Cut",

        ResKey.TEMPLATE1_PRICE2_TITLE to "Blow Dry",

        ResKey.TEMPLATE1_PRICE3_TITLE to "Colour & Finish",

        ResKey.TEMPLATE1_PRICE4_TITLE to "Balayage",

        ResKey.TEMPLATE1_PRICE5_TITLE to "Highlights",

        ResKey.TEMPLATE1_PRICE6_TITLE to "Bridal Hair",
        ResKey.TEMPLATE1_GALLERY_BADGE to "GALLERY",
        ResKey.TEMPLATE1_GALLERY_TITLE to "Highlighted work",
        ResKey.TEMPLATE1_SERVICE_DESC to " A collection of styles created with passion and care.",

        ResKey.TEMPLATE1_INFO_DESC to "Products I Use",

        ResKey.TEMPLATE1_ABOUT_TITLE to "Professional products.",

        ResKey.TEMPLATE1_ABOUT_PARAGRAPH to
                "I carefully select every product I use in the salon. They're chosen for their performance, quality and commitment to healthy, beautiful hair.",

        ResKey.TEMPLATE1_HERO_FEATURE1_TITLE to
                "Professional Quality",

        ResKey.TEMPLATE1_HERO_FEATURE1_TEXT to
                "Salon-grade products that deliver results you can see and feel.",

        ResKey.TEMPLATE1_HERO_FEATURE2_TITLE to
                "Kind to Your Hair",

        ResKey.TEMPLATE1_HERO_FEATURE2_TEXT to
                "Formulas chosen to nourish, protect and keep your hair in the best condition.",

        ResKey.TEMPLATE1_HERO_FEATURE3_TITLE to
                "Cruelty-Free Options",

        ResKey.TEMPLATE1_HERO_FEATURE3_TEXT to
                "I choose brands that are committed to cruelty-free practices where possible.",

        ResKey.TEMPLATE1_HERO_FEATURE4_TITLE to
                "Responsible Choices",

        ResKey.TEMPLATE1_HERO_FEATURE4_TEXT to
                "Thoughtfully selected brands with a focus on sustainability and responsible beauty.",

        ResKey.TEMPLATE1_REVIEWS_BADGE to "Client Love",

        ResKey.TEMPLATE1_REVIEWS_TITLE to "Words From My Clients",

        ResKey.TEMPLATE1_REVIEWS_TEXT to
                "A few kind words from some of the lovely people I've had the pleasure of styling.",

        ResKey.TEMPLATE1_CONTACT_BADGE to "Get In Touch",

        ResKey.TEMPLATE1_CONTACT_TITLE to "Let's Talk About Your Hair",

        ResKey.TEMPLATE1_CONTACT_SUBTITLE to
                "Ready for a new look? Get in touch and let's find a time that works for you.",

        ResKey.TEMPLATE1_CONTACT_SUBTITLE2 to "Visit The Salon",


        ResKey.TEMPLATE1_CONTACT_ADDRESS_TITLE to "ADDRESS",

        ResKey.TEMPLATE1_CONTACT_PHONE_TITLE to "PHONE",

        ResKey.TEMPLATE1_CONTACT_EMAIL_TITLE to "EMAIL",
        ),
)
